var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"55","height":"77","viewBox":"0 0 55 77","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"opacity":"0.9","width":"55","height":"77","rx":"12","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }